<div class="field-spacer" [ngStyle]="{'height' : field.size + 'px'}"></div>
